import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { slugs } from "../../../Constant/slugs";
import { AdsGETApiAuth, AdsPUTApi } from "../../../Constant/api";
import DataTable from "react-data-table-component";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";

const columns = [
  {
    id: 1,
    name: "id",
    selector: (row) => row.id,
    sortable: true,
    reorder: true,
    width: "100px"
  },
  {
    id: 2,
    name: "Title",
    selector: (row) => row.title.rendered,
    sortable: true,
    reorder: true
  },
  {
    id: 3,
    name: "Receipt Number",
    selector: (row) => row.meta.receipt_number,
    sortable: true,
    reorder: true
  },
  {
    id: 4,
    name: "Payment Type",
    selector: (row) => row.meta.payment_type,
    sortable: true,
    reorder: true
  },
  {
    id: 5,
    name: "Student Name",
    selector: (row) => row.meta.student_name,
    sortable: true,
    reorder: true
  },
  {
    id: 6,
    name: "Date",
    selector: (row) => row.meta.payment_date,
    sortable: true,
    reorder: true
  },
  {
    id: 7,
    name: "Payment Mode",
    selector: (row) => row.meta.payment_mode,
    sortable: true,
    reorder: true
  },
  {
    id: 8,
    name: "Amount",
    selector: (row) => row.meta.amount,
    sortable: true,
    reorder: true
  },
  {
    name: "View",
    cell: (row) => <Link to={`${slugs.payments_received_details}${row.slug}`}>View</Link>,

  }
];

export default function AllPaymentReceived() {
  const [Projects1, setProjects1] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [Reload, setReload] = React.useState(false)
  const [deleteUsersModal, setDeleteUsersModal] = React.useState(false)
  const [serachName, setSearchName] = React.useState("")
  const [TotalToday, setTotalToday] = React.useState("")
  const [PaymentDate, setPaymentDate] = React.useState("")

  const [Total, setTotal] = React.useState("")
  const dmyToIso = (date) => {
    const year = date.getFullYear()
    const month = date.getMonth() < 9 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`
    const day = date.getDate() < 9 ? `0${date.getDate()}` : `${date.getDate()}`
    return `${year}-${month}-${day}`
  };
  const date = new Date()

  const GetAllProjects = (params) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth(
      {
        per_page: 10000,
        _fields: "id,title,slug,meta,date"
      }, slugs.db_slug_payments_received)
      .then((res) => {
        setProjects1(res.data)
        setCustomersList(res.data)
        const ExpenseToday = res.data.filter(a => a.date.includes(dmyToIso(date)))
        var todayTotal = 0;
        for (let i = 0; i < ExpenseToday.length; i++)
          todayTotal += Number(ExpenseToday[i].meta.amount)
        setTotalToday(todayTotal)
        const ExpenseSelect = res.data
        var Total = 0;
        for (let i = 0; i < ExpenseSelect.length; i++)
          Total += Number(ExpenseSelect[i].meta.amount)
        setTotal(Total)
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  useEffect(() => {
    GetAllProjects()
  }, [])


  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>All Income</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Income
        </div>
      </div>
      <a href={slugs.new_payments_received}>
        <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}>
          Add New Income
        </div>
      </a>


      <div className="row">
        <div className="col-md-6">
          <div style={{ display: "inline", cursor: "pointer" }}>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setCustomersList(Projects1)
              }}
            >
              All ({Projects1.length}) |
            </div>
          </div>
          {/* <div style={{ display: "inline", cursor: "pointer" }}>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setDeleteUsersModal(Projects1)
              }}
            >
              Delete All
            </div>
          </div> */}
        </div>
        <div className="col-md-6 row">
          {/* <div className="col-4" /> */}
          <input className="col-4" style={{ margin: "1px 2px", padding: "3px 2px" }}
            value={serachName} placeholder="Name"
            onChange={(event) => {
              setSearchName(event.target.value)
              setCustomersList(Projects1.filter(a => a.title.rendered.includes(event.target.value)))
            }}
          />
          {/* <input className="col-4" style={{ margin: "1px 2px", padding: "3px 2px" }}
            value={serachName} placeholder="Date" type="date"
            onChange={(event) => {
              // setSearchName(event.target.value)
              console.log(event.target.value)
              const ExpenseSelect = Projects1.filter(a => a.date.includes(event.target.value))
              setCustomersList(Projects1.filter(a => a.date.includes(event.target.value)))
              var todayTotal = 0;
              for (let i = 0; i < ExpenseSelect.length; i++)
                todayTotal += Number(ExpenseSelect[i].meta.amount)
              setTotal(todayTotal)
            }}
          /> */}
          <div className="col-4">
            <div className="attendance-date-picker">
              <div className="small-nepali-datepicker"
              >
                {/* {item.date} */}
                <NepaliDatePicker style={{ cursor: "pointer" }}
                  inputClassName="input-common" placeholder={"date"}
                  value={PaymentDate || ""}
                  onChange={(selectedDate) => {
                    setPaymentDate(selectedDate)
                    // console.log(event.target.value)
                    const ExpenseSelect = Projects1.filter(a => a.meta.payment_date.includes(selectedDate))
                    setCustomersList(Projects1.filter(a => a.meta.payment_date.includes(selectedDate)))
                    var todayTotal = 0;
                    for (let i = 0; i < ExpenseSelect.length; i++)
                      todayTotal += Number(ExpenseSelect[i].meta.amount)
                    setTotal(todayTotal)
                  }
                  }
                  options={{
                    calenderLocale: "ne",
                    valueLocale: "en",
                  }}
                  placeholder="मिति छान्नुहोस्"
                // onSelect={() => { setOpencalendar(true) }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        Total Today:{TotalToday}&nbsp;
        Total Selected:{Total}
      </div>
      <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px" }}>
        <DataTable
          columns={columns}
          data={CustomersList}
          defaultSortFieldId={1}
          defaultSortAsc={false}
          striped
          // sortIcon={<SortIcon />}
          paginationPerPage={100}
          paginationRowsPerPageOptions={[10, 50, 100, 1000]}
          pagination
          selectableRows
        />
      </div>
      {deleteUsersModal &&
        <section className="modal" >
          <div className="row" style={{ overflow: "hidden" }}>
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'hidden', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setDeleteUsersModal(false)
                  }}
                >X</div>
                Do you really want to Delete all the income?<br />
                <div className="row">
                  <div className="col-3 center " >
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        setDeleteUsersModal(false)
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div className="col-3 center">
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        for (let i = 0; i < Projects1.length; i++) {
                          setReload(true)
                          setDeleteUsersModal(false)
                          AdsPUTApi({
                            status: "draft"
                          }, slugs.db_slug_payments_received, Projects1[i].id)
                            .then((res) => {
                              if (i == Projects1.length - 1) {
                                GetAllProjects()
                              }
                            })
                            .catch((err) => {
                              console.log(err)
                            })

                        }
                      }}
                    >
                      Delete all Income
                    </div>
                  </div>
                </div>
                <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px", border: "1px solid #999" }}>
                  <DataTable
                    paginationPerPage={100}
                    paginationRowsPerPageOptions={[10, 50, 100, 1000]}
                    columns={columns}
                    data={Projects1}
                    defaultSortFieldId={1}
                    defaultSortAsc={false}
                    striped
                    // sortIcon={<SortIcon />}
                    pagination
                    selectableRows={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

      }
      {Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
    </div>
  )
}